var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _initialiseProps;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';

import RXInputGroup from './RXInputGroup';
import RXInput from './RXInput';

var logdown = require('logdown');
var console = logdown('rx-forms-rx-inline-form-group', { prefixColor: '#2196f3' });
var console2 = logdown('rx-forms-rx-inline-form-group-debug', { prefixColor: 'red' });

var RXInlineFormGroup = (_temp = _class = function (_Component) {
    _inherits(RXInlineFormGroup, _Component);

    function RXInlineFormGroup(props) {
        _classCallCheck(this, RXInlineFormGroup);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _initialiseProps.call(_this);

        console.log('23000 formData: ', _this.props.formData);
        console.log('groups: ', _this.props.group);
        console.log('prefix: ', _this.props.prefix);
        var fragmentData = {};
        _this.props.group.map(function (element, index) {
            var type = element.type;

            console.log('23000 map group with ', element);
            var elementName = '' + _this.props.prefix + element.name;
            if (_this.props.formData && _this.props.formData[elementName]) {
                console.log('23000 Array formdata');

                fragmentData[elementName] = _this.props.formData[elementName];
            } else {

                if (element.type == "checkbox" || element.type == "switch") {
                    console2.log('23000 inside formname and check for ', elementName);
                    fragmentData[elementName] = false; //this.props.formData[element.name]
                    _this.props.parentOnChange({ target: { type: type, value: false, id: elementName } });
                } else {
                    console2.log('23000 inside formname regular ', elementName);
                    fragmentData[elementName] = ""; //this.props.formData[element.name]
                    _this.props.parentOnChange({ target: { type: type, value: "", id: elementName } });
                }
            }
        });

        _this.state = { fragmentData: fragmentData };
        console.log('passed formData: ' + JSON.stringify(_this.props.formData));
        console2.log('in LOAD FRAGMENTDATA: ', fragmentData);
        return _this;
    }

    RXInlineFormGroup.prototype.render = function render() {
        var _this2 = this;

        var colSpacing = Math.round(12 / this.props.group.length);

        console.log('0 with prefix: ' + this.props.prefix);
        return React.createElement(
            FormGroup,
            { row: true },
            this.props.group.map(function (element, index) {

                var hasAddons = element.addons !== undefined;
                var validators = element.validators === undefined ? [] : element.validators;
                var formvalidators = _this2.props.formvalidators;
                console.log('with prefix: ' + _this2.props.prefix);
                var elementName = '' + _this2.props.prefix + element.name;
                console.log('after elementName: ' + elementName);
                var prefix = _this2.props.prefix;
                console.log('fragmentData: ', _this2.state.fragmentData);

                var name = element.name,
                    cleanElement = _objectWithoutProperties(element, ['name']);

                return React.createElement(
                    Col,
                    { key: index, sm: colSpacing },
                    element.type !== "checkbox" && element.type !== "switch" ? React.createElement(
                        Label,
                        { 'for': element.name },
                        element.label
                    ) : React.createElement(Label, { 'for': element.name }),
                    hasAddons ? React.createElement(RXInputGroup, { events: _this2.props.events, group: element, prefix: prefix, parentOnChange: _this2.onChange, formvalidators: formvalidators, validators: validators, formData: _this2.props.formData, errors: _this2.props.errors, transformers: _this2.props.transformers, formstore: _this2.props.formstore }) : React.createElement(
                        'div',
                        { style: { position: "relative" } },
                        element.type !== "checkbox" && element.type !== "switch" ? React.createElement(RXInput, _extends({ label: element.label, type: element.type, name: elementName, value: _this2.state.fragmentData[elementName], onChange: _this2.onChange, id: elementName, formvalidators: formvalidators, validators: validators, errors: _this2.props.errors, formstore: _this2.props.formstore, transformers: _this2.props.transformers }, cleanElement)) : React.createElement(RXInput, _extends({ label: element.label, type: element.type, name: elementName, value: _this2.state.fragmentData[elementName], onChange: _this2.onChange, id: elementName, formvalidators: formvalidators, validators: validators, errors: _this2.props.errors, formstore: _this2.props.formstore, transformers: _this2.props.transformers }, cleanElement))
                    )
                );
            })
        );
    };

    return RXInlineFormGroup;
}(Component), _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.componentDidUpdate = function (prevProps) {

        console2.log('changed for  with', _this3.props.formData, ' for ', _this3.props.group);
        if (_this3.props.formData != prevProps.formData) {
            console2.log('changed formdata with', _this3.props.formData, ' for ', _this3.props.group);

            var fragmentData = {};

            _this3.props.group.map(function (element, index) {
                var type = element.type;

                console.log('23000 map group with ', element);
                var elementName = '' + _this3.props.prefix + element.name;
                if (_this3.props.formData && _this3.props.formData[elementName]) {
                    console.log('23000 Array formdata');
                    fragmentData[elementName] = _this3.props.formData[elementName];
                } else {

                    if (element.type == "checkbox" || element.type == "switch") {
                        console2.log('23000 inside formname and check for ', elementName);
                        fragmentData[elementName] = false; //this.props.formData[element.name]
                        _this3.props.parentOnChange({ target: { type: type, value: false, id: elementName } });
                    } else {
                        console2.log('23000 inside formname regular ', elementName);
                        fragmentData[elementName] = ""; //this.props.formData[element.name]
                        _this3.props.parentOnChange({ target: { type: type, value: "", id: elementName } });
                    }
                }
            });
            _this3.setState({ fragmentData: fragmentData });
            console2.log('in UPDATE FRAGMENTDATA', fragmentData);
        }
    };

    this.onChange = function (event) {

        var value = event.target.type === 'checkbox' || event.target.type === 'switch' ? event.target.checked : event.target.value;
        console.log('in onchange with event ' + value + ' type ' + event.target.type + ' and target: ' + event.target.id);

        var val = value;
        var id = event.target.id;

        _this3.setState(function (prevState) {
            var fragmentData = prevState.fragmentData;
            fragmentData[id] = val;

            return { fragmentData: fragmentData };
        });

        console.log('log state: ' + JSON.stringify(_this3.state));
        _this3.props.parentOnChange({ target: { type: event.target.type, value: value, id: id } });
        //this.props.parentOnChange(event);
    };
}, _temp);


RXInlineFormGroup.defaultProps = {
    prefix: "",
    events: {}
};

export default RXInlineFormGroup;